@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

.card {
  @include cxy.font-size('text-m');
  line-height: var(--cxy-lineHeight-l);
  height: var(--cxy-card-height, max-content);
  color: var(--cxy-color-text-default-body);

  @include cxy.screen-size('desktop') {
    line-height: var(--cxy-lineHeight-xxs);
  }
}

.primary {
  background-color: var(--cxy-color-surface-success-default-subtle-hover);
}

.secondary {
  background-color: color-mix(in srgb, var(--cxy-color-surface-page), transparent 96%);
}

.padding-s {
  padding: var(--cxy-spacing-xxxsm);
}

.padding-m {
  padding: var(--cxy-spacing-xxsm);
}

.padding-l {
  padding: var(--cxy-spacing-xsm);
}

.borderRadius-s {
  border-radius: var(--cxy-border-radius-s);
}

.borderRadius-m {
  border-radius: var(--cxy-border-radius-m);
}

.borderRadius-l {
  border-radius: var(--cxy-border-radius-l);
}

.shouldCenter {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
}
